<template>
  <div>
    <RecentRecipes />
  </div>
</template>

<script>
import RecentRecipes from "../components/UI/RecentRecipes";

export default {
  components: {
    RecentRecipes,
  },
};
</script>

<style>
</style>